__turbopack_context__.v({
  "button": "sidebar-module__qlM12W__button",
  "childrenMenuMain": "sidebar-module__qlM12W__childrenMenuMain",
  "childrenMenuShowAllContent": "sidebar-module__qlM12W__childrenMenuShowAllContent",
  "leftAlignment": "sidebar-module__qlM12W__leftAlignment",
  "mainMenu": "sidebar-module__qlM12W__mainMenu",
  "mobileSidebarFilter": "sidebar-module__qlM12W__mobileSidebarFilter",
  "rightAlignment": "sidebar-module__qlM12W__rightAlignment",
  "searchBoxFullWidth": "sidebar-module__qlM12W__searchBoxFullWidth",
  "sidebar": "sidebar-module__qlM12W__sidebar",
  "sidebarFlex": "sidebar-module__qlM12W__sidebarFlex",
  "sidebarHiddenShow": "sidebar-module__qlM12W__sidebarHiddenShow",
  "sidebarHiddenStyle": "sidebar-module__qlM12W__sidebarHiddenStyle",
  "sidebarMenu": "sidebar-module__qlM12W__sidebarMenu",
  "sidebarTitle": "sidebar-module__qlM12W__sidebarTitle",
  "subMenu": "sidebar-module__qlM12W__subMenu",
  "subMenuHidden": "sidebar-module__qlM12W__subMenuHidden",
  "subMenuShow": "sidebar-module__qlM12W__subMenuShow",
  "textIconAlignment": "sidebar-module__qlM12W__textIconAlignment",
  "typeOfMenuAlignment": "sidebar-module__qlM12W__typeOfMenuAlignment",
});
